module.exports = __webpack_public_path__ + "img/DSC_0042.b2a0fa20.jpg";